import { chatbot_Tags } from "src/api"

export const getTagIds = (tags?: chatbot_Tags) =>
    tags !== undefined ? Object.keys(tags).map(Number) : []
